'use client';

import * as React from 'react';

import { Eye, EyeOff } from 'lucide-react';
import { cn } from '@/lib/utils';

export type InputProperties = Omit<React.ComponentProps<'input'>, 'form'> & { showPasswordToggle?: boolean };

const Input = ({
    className, type, showPasswordToggle = true, disabled, ...properties
}: InputProperties) => {
    const [visible, setVisible] = React.useState(false);

    const isPassword = type === 'password';
    const inputType = isPassword && showPasswordToggle
        ? (visible ? 'text' : 'password')
        : type;

    React.useEffect(() => {
        if (disabled) {
            setVisible(false);
        }
    }, [disabled]);

    return (
        <div className="relative w-full">
            <input
                type={inputType}
                data-slot="input"
                className={cn(
                    'border-input file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground aria-invalid:outline-destructive/60 aria-invalid:ring-destructive/20 dark:aria-invalid:outline-destructive dark:aria-invalid:ring-destructive/50 ring-ring/10 dark:ring-ring/20 dark:outline-ring/40 outline-ring/50 aria-invalid:outline-destructive/60 dark:aria-invalid:outline-destructive dark:aria-invalid:ring-destructive/40 aria-invalid:ring-destructive/20 aria-invalid:border-destructive/60 dark:aria-invalid:border-destructive flex h-9 w-full min-w-0 rounded-md border px-3 py-1 text-base shadow-xs transition-[color,box-shadow] file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:ring-4 focus-visible:outline-1 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:focus-visible:ring-[3px] aria-invalid:focus-visible:outline-none md:text-sm dark:aria-invalid:focus-visible:ring-4',
                    className
                )}
                disabled={disabled}
                {...properties}
            />
            {isPassword && showPasswordToggle && (
                <button
                    type="button"
                    className="absolute inset-y-0 right-3 flex items-center text-muted-foreground"
                    onClick={() => setVisible(!visible)}
                    disabled={disabled}
                >
                    {visible
                        ? <Eye size={18} />
                        : <EyeOff size={18} />}
                </button>
            )}
        </div>
    );
};

export { Input };
